import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANG, LANG_CODES } from "./config";
import en from "./en";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const missing = new Set();

// Backend-backed resource loader: non-English bundles are fetched + merged over English.
// Drafts are NEVER exposed by a public query param — the backend only returns Draft/Needs-Review
// strings when the request carries an authenticated admin/staff session (credentials included).
// Anonymous/production visitors always receive Approved-only translations.
async function loadRemote(lng) {
  if (lng === "en") return;
  try {
    const res = await fetch(`${API}/i18n/${encodeURIComponent(lng)}?preview=1`, { credentials: "include" });
    if (!res.ok) return;
    const data = await res.json();
    if (data && data.translation) i18n.addResourceBundle(lng, "translation", data.translation, true, true);
  } catch (e) { /* English fallback stays in effect */ }
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  defaultNS: "translation",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  saveMissing: true,
  missingKeyHandler: (lngs, ns, key) => {
    const id = `${lngs[0]}:${key}`;
    if (!missing.has(id)) { missing.add(id); console.warn("[i18n] missing", id); }
  },
  react: { useSuspense: false },
});

const loaded = new Set([DEFAULT_LANG]);
export async function ensureLanguage(lng) {
  const code = LANG_CODES.includes(lng) ? lng : DEFAULT_LANG;
  if (!loaded.has(code)) { await loadRemote(code); loaded.add(code); }
  if (i18n.language !== code) await i18n.changeLanguage(code);
}

export const reportedMissing = () => Array.from(missing);
export default i18n;
